export * from './RoundedCrossIcon';
